import { ChangeDetectionStrategy, Component, HostListener, Input } from '@angular/core';
import { Link, MenuContent } from 'src/core-lib/navigation/models/link.model';
import { OverlayService } from 'src/layout/overlay/services/overlay.service';

@Component({
    selector: 'app-overlay-dropdown',
    templateUrl: './overlay-dropdown.component.html',
    styleUrls: ['./overlay-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayDropdownComponent {
    @Input() menu: (Link | MenuContent)[];

    constructor(private overlayService: OverlayService) {}
    @HostListener('document:keydown.escape')
    @HostListener('click')
    close() {
        this.overlayService.close();
    }
}
